import React from "react";
import {
  Grid,
} from "@material-ui/core";
import CategoryIcon from "../CategoryIcon";

const SafetyCategoryOptions = ({
  name,
  subCategories,
  index,
}) => {  

  return (
    <Grid container className="left-align" wrap="nowrap">
      <CategoryIcon category={name.includes("Tires") ? "Tires" : name} /> 
      <Grid item container direction="column" style={{ gap: 16 }}>
        <h5>{name}</h5>
        <Grid item container direction="column" style={{ gap: 12 }}>
          {subCategories.map((subCategory, index) => (
            <h6 key={index} className={"font-bold"}>
              {subCategory.name}
            </h6>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SafetyCategoryOptions;
